var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnveloppe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.92 0 0 8.92 0 20v60c0 11.08 8.92 20 20 20h60c11.08 0 20-8.92 20-20V20c0-11.08-8.92-20-20-20H20zm-1.373 21.096h62.746c3.642 0 6.682 3.042 6.682 6.683v44.444c0 3.641-3.04 6.681-6.682 6.681H18.627c-3.642 0-6.682-3.04-6.682-6.681V27.779c0-3.641 3.04-6.683 6.682-6.683zm4.025 7 27.352 28.31 27.475-28.31H22.652zm-3.707 3.36v36.439l17.907-17.907-17.907-18.533zm62.11.134L63.05 50.14l18.004 18.005V31.59zM40.326 53.584l-18.32 18.32h55.738L59.568 53.73l-7.773 8.011a2.5 2.5 0 0 1-3.594-.004l-7.875-8.152z",
    opacity: 1,
    fill: "#7f353b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 3.79999995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    className: "fill-000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnveloppe);
export default __webpack_public_path__ + "static/media/enveloppe.b8265601e01cde44bc7a043d41f4fd45.svg";
export { ForwardRef as ReactComponent };